const ROOT = "HtmlComponent";
const IFRAME_COMPONENT = "iframeComponent";
const TOOLBAR_BUTTON_EDIT_HTML = "baseToolbarButton_edit";
const EDIT_PANEL_RADIO_HTML = "htmlEditPanel_radioHtml";
const EDIT_PANEL_RADIO_URL = "htmlEditPanel_radioUrl";
const EDIT_PANEL_HTML_INPUT = "htmlEditPanel_htmlInput";
const EDIT_PANEL_CANCEL_BUTTON = "htmlEditPanel_Cancel";
const EDIT_PANEL_UPDATE_BUTTON = "htmlEditPanel_Update";

export { EDIT_PANEL_CANCEL_BUTTON, EDIT_PANEL_HTML_INPUT, EDIT_PANEL_RADIO_HTML, EDIT_PANEL_RADIO_URL, EDIT_PANEL_UPDATE_BUTTON, IFRAME_COMPONENT, ROOT, TOOLBAR_BUTTON_EDIT_HTML };
//# sourceMappingURL=dataHooks.js.map
